import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import { _ as r } from "../../chunks/tslib.es6.js";
import { strict as e } from "../../core/jsonMap.js";
import { JSONSupport as o } from "../../core/JSONSupport.js";
import { isDataProtocol as t, isAbsolute as s, normalize as p } from "../../core/urlUtils.js";
import { property as c } from "../../core/accessorSupport/decorators/property.js";
import "../../core/arrayUtils.js";
import "../../core/has.js";
import "../../core/accessorSupport/ensureType.js";
import { enumeration as i } from "../../core/accessorSupport/decorators/enumeration.js";
import { reader as a } from "../../core/accessorSupport/decorators/reader.js";
import { subclass as m } from "../../core/accessorSupport/decorators/subclass.js";
import { writer as f } from "../../core/accessorSupport/decorators/writer.js";
import { f as u, t as l } from "../../chunks/persistableUrlUtils.js";

var _n;

var d = e()({
  circle: "circle",
  square: "square",
  cross: "cross",
  x: "x",
  kite: "kite",
  triangle: "triangle"
});

var h = _n = /*#__PURE__*/function (_o) {
  _inherits(n, _o);

  var _super = _createSuper(n);

  function n(r) {
    _classCallCheck(this, n);

    return _super.call(this, r);
  }

  _createClass(n, [{
    key: "readHref",
    value: function readHref(r, e, o) {
      return r ? u(r, o) : e.dataURI;
    }
  }, {
    key: "writeHref",
    value: function writeHref(r, e, o, c) {
      r && (t(r) ? e.dataURI = r : (e.href = l(r, c), s(e.href) && (e.href = p(e.href))));
    }
  }, {
    key: "clone",
    value: function clone() {
      return new _n({
        href: this.href,
        primitive: this.primitive
      });
    }
  }]);

  return n;
}(o);

r([c({
  type: String,
  json: {
    write: !0,
    read: {
      source: ["href", "dataURI"]
    }
  }
})], h.prototype, "href", void 0), r([a("href")], h.prototype, "readHref", null), r([f("href", {
  href: {
    type: String
  },
  dataURI: {
    type: String
  }
})], h.prototype, "writeHref", null), r([i(d)], h.prototype, "primitive", void 0), h = _n = r([m("esri.symbols.support.IconSymbol3DLayerResource")], h);
var j = "circle",
    y = h;
export { h as IconSymbol3DLayerResource, y as default, j as defaultPrimitive };